import { getMetrics } from './metrics';

const metrics = getMetrics();
const imageLoadHistogram = metrics.getHistogram(
  'image_load',
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  [100, 200, 400, 800, 1600, 3200, 6400, 12800, 25600, 51200]
);

export function trackImageLoad({
  loadTime,
  error = false,
}: {
  loadTime: number;
  error?: boolean;
}): void {
  imageLoadHistogram.observe(
    {
      error: error.toString(),
    },
    loadTime
  );
}
